import { Link } from "react-router-dom";
import type { Film } from "@/types/film";

interface FilmCardProps {
  film: Film;
}

export default function FilmCard({ film }: FilmCardProps) {
  const episodeLabel = film.type === "剧集" ? `${film.episodeCount}集` : film.duration;

  return (
    <Link
      to={`/detail/${film.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200/90 bg-background-50 transition-colors duration-300 hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={film.poster}
          alt={`${film.title} 海报`}
          title={`${film.title} 韩国影视作品封面`}
          className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-primary-950/80 to-transparent" />
        <span className="absolute left-2 top-2 rounded bg-primary-950/70 px-2 py-1 text-[10px] font-medium tracking-wide text-background-50 backdrop-blur-sm">
          {film.type}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded bg-accent-500 px-1.5 py-1 text-[11px] font-semibold text-primary-950">
          <i className="ri-star-fill text-[9px]" />
          {film.rating.toFixed(1)}
        </span>
        <span className="absolute inset-x-2 bottom-2 flex items-center justify-between text-[11px] text-background-100">
          <span>{episodeLabel}</span>
          <span>{film.year}</span>
        </span>
      </div>

      <div className="flex flex-1 flex-col gap-2 p-3">
        <h3 className="line-clamp-1 text-[15px] font-medium text-foreground-950 transition-colors group-hover:text-primary-700">
          {film.title}
        </h3>
        <p className="line-clamp-1 text-[11px] font-light tracking-wide text-foreground-500">{film.originalTitle}</p>
        <div className="mt-auto flex flex-wrap items-center gap-1.5 pt-1">
          {film.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="rounded bg-secondary-100 px-1.5 py-0.5 text-[10px] text-secondary-800"
            >
              {genre}
            </span>
          ))}
          <span className="ml-auto text-[10px] text-foreground-400">{film.updatedAt.slice(5)} 更新</span>
        </div>
      </div>
    </Link>
  );
}